import { EventInput } from '@fullcalendar/core';
import { CalendarEventModel } from '../../../../../../api-service/clients';
import { ColorPalette } from '../../../../../../components/config';
import { createBaseCalendarEventInput, parseEventDate } from './helpers';

// Gul adskiller medicin fra de blå aftale-typer; doserne er skrivebeskyttede projektioner.
const MEDICINE_EVENT_COLOR = ColorPalette.PickledEggyolk;

export function mapMedicineCalendarEvent(
  event: CalendarEventModel
): EventInput | null {
  const startDate = parseEventDate(event.startDate);
  const endDate = parseEventDate(event.endDate);
  if (!startDate || !endDate) {
    return null;
  }

  return {
    ...createBaseCalendarEventInput(event),
    start: startDate,
    end: endDate,
    allDay: false,
    backgroundColor: MEDICINE_EVENT_COLOR,
    borderColor: MEDICINE_EVENT_COLOR,
    textColor: ColorPalette.DefaultTextColor,
    extendedProps: {
      type: event.type,
      content: event.content,
      eventStatus: event.eventStatus,
    },
  };
}
